import { useCallback, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { getElementBySelectorAsync } from '~/utils/dom'

const useScrollToElement = (): void => {
  const { hash } = useLocation()

  const scrolledRef = useRef(false)

  const hashRef = useRef(hash)

  const scrollToElement = useCallback(async (hash: string) => {
    const id = hash.substring(1)
    const root = document.getElementById('root')

    // NOTE: used to compute the offset
    const element = await getElementBySelectorAsync(id, true)
    const headerRef = await getElementBySelectorAsync('.header-component')
    const filtersRef = await getElementBySelectorAsync('.filters-component')
    const viewTitleRef = await getElementBySelectorAsync('.layout-view-title')

    if (element && root) {
      const yOffset = headerRef.clientHeight + viewTitleRef.clientHeight + filtersRef.clientHeight
      const y = element.getBoundingClientRect().top + window.scrollY - yOffset - 10

      root.scrollTo({ behavior: 'smooth', top: y })
      scrolledRef.current = true
    }
  }, [])

  useEffect(() => {
    if (hash) {
      /** Because the hash could contain the search params ?? */
      const formattedHash = hash.split('?')[0]

      // We want to reset if the hash has changed
      if (hashRef.current !== formattedHash) {
        hashRef.current = formattedHash
        scrolledRef.current = false
      }

      // only attempt to scroll if we haven't yet (this could have just reset above if hash changed)
      if (!scrolledRef.current) {
        scrollToElement(formattedHash)
      }
    }
  }, [hash, scrollToElement])
}

export default useScrollToElement
